import { useScopedSelector } from 'ia-react-core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CommunicationPreferences } from '../../../interfaces/CommunicationPreferences';
import { StyledTile, StyledDiv } from './Content.styles';
import ServicesSection from './ServicesSection';

export interface ContentProps { }

const Content: FC<ContentProps> = () => {
  const { t } = useTranslation('PreferencesTile');
  const preferences: CommunicationPreferences = useScopedSelector('/App.features.preferences.communication.current');

  if (!preferences || !preferences.hasAccess || preferences.documentPreferences.length === 0) return null;

  return (
    <StyledTile data-testid="preferencesTile" title={t('title')} isDivided>
      <StyledDiv>
        <ServicesSection />
      </StyledDiv>
    </StyledTile>
  );
};

export default Content;
